module.exports = __webpack_public_path__ + "img/work_13.e53b6148.png";